export default "__VITE_ASSET__BjeL2SFE__"